import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "sidebar"];

  connect() {
    console.log("NavController connected");
  }

  toggleSidebar() {
    this.sidebarTarget.classList.toggle("translate-x-0");
    this.sidebarTarget.classList.toggle("-translate-x-full");
  }

  toggleMenu() {
    this.menuTarget.classList.toggle("hidden");
  }
}
